import { Action } from "redux";

export type ClearCMSToken = "CLEAR_CMS_TOKEN";
export const CLEAR_CMS_TOKEN: ClearCMSToken = "CLEAR_CMS_TOKEN";

export interface ClearCMSTokenAction extends Action {
    type: ClearCMSToken;
    payload: {
        appId: string;
    };
}

export function clearCMSToken(appId: string): ClearCMSTokenAction {
    return {
        payload: {
            appId
        },
        type: CLEAR_CMS_TOKEN
    };
}
